import { CommonHelper } from '@core/services/common';
import { orderBy } from 'lodash';

/**
 * Merge raw check-sheet data từ DynamoDB response (array of sortKey items)
 * thành flat array, parse JSON, sort notice_list/attention_list.
 */
export function mergeCheckSheetRawData(rawResult: any[]): any[] {
  return rawResult.reduce((acc: any[], curr: any) => {
    const sortKeyInfo = curr?.sortKey?.split('#');
    const blockCd = sortKeyInfo[0]?.split('_')[1];
    const unitCd = sortKeyInfo[2]?.split('_')[1];
    if (curr.jsonData) {
      let parsed: any[] = JSON.parse(curr.jsonData);
      parsed = parsed.map((item: any) => {
        item.user.blockcd = blockCd;
        item.user.unitcd = unitCd;
        return {
          ...item,
          notice_list: item?.notice_list
            ?.sort((a: any, b: any) => new Date(b?.upddate).getTime() - new Date(a?.upddate).getTime())
            ?.map((notice: any) => ({
              ...notice,
              message: '【' + `${notice?.type_name ?? ''} 】： ${notice?.message ?? ''}`,
            })) ?? {},
          attention_list: (CommonHelper.distinctObjects(item?.attention_list ?? []))
            .sort((a: any, b: any) => new Date(b?.upddate).getTime() - new Date(a?.upddate).getTime())
            ?.map((x: any) => ({
              ...x,
              isMapByType: true,
            })) ?? {},
        };
      });
      acc.push(...parsed);
    }
    return acc;
  }, [] as any[]);
}

/**
 * Build dropdown data cho block/unit selector từ API response.
 * Bỏ qua block có blockcd='91'.
 */
export function buildBlockUnitDropdown(resData: any): any[] {
  if (!resData) return [];
  const dropdownData: any[] = [];
  resData?.BlockList?.forEach((block: any) => {
    if (block?.blockcd !== '91') {
      dropdownData.push({ name: block?.blocknm, value: block?.blockcd });
      resData?.UnitList?.filter((unit: any) => unit?.blockcd === block?.blockcd)
        .forEach((unit: any) => {
          dropdownData.push({
            name: block?.blocknm + ' ' + unit?.unitnm,
            value: block?.blockcd + '-' + unit?.unitcd,
          });
        });
    }
  });
  return dropdownData;
}

/**
 * Build dropdown data cho group selector từ API response.
 * Kết quả được sort theo sk (blockCd-unitCd-groupKbnCd[-groupcd]).
 */
export function buildGroupDropdown(resData: any): any[] {
  if (!resData) return [];
  let dropdownData: any[] = [];
  const groupCks = resData?.groupKbns;
  if (groupCks?.length > 0) {
    const sortedKbns = orderBy(groupCks, [
      (grKbn: any) => grKbn?.blockCd,
      (grKbn: any) => grKbn?.unitCd,
      (grKbn: any) => Number(grKbn?.sortNo ?? 0),
      (grKbn: any) => grKbn?.groupKbnCd,
    ]);
    sortedKbns.forEach((grKbn: any) => {
      dropdownData.push({
        name: grKbn?.groupKbnNm,
        value: grKbn?.blockCd + '-' + grKbn?.unitCd + '-' + grKbn?.groupKbnCd,
        sk: `${grKbn?.blockCd === '00' ? '99' : grKbn?.blockCd}-${grKbn?.unitCd === '000' ? '999' : grKbn?.unitCd}-${grKbn?.groupKbnCd}`,
      });
      const sortedGroups = orderBy(grKbn?.groups ?? [], [
        (gr: any) => Number(gr?.sortNo ?? 0),
        (gr: any) => gr?.groupcd,
      ]);
      sortedGroups.forEach((gr: any) => {
        dropdownData.push({
          name: grKbn?.groupKbnNm + ' ' + gr?.groupNm,
          value: grKbn?.blockCd + '-' + grKbn?.unitCd + '-' + grKbn?.groupKbnCd + '-' + gr?.groupcd,
          sk: `${grKbn?.blockCd === '00' ? '99' : grKbn?.blockCd}-${grKbn?.unitCd === '000' ? '999' : grKbn?.unitCd}-${grKbn?.groupKbnCd}-${gr?.groupcd}`,
          daiList: gr?.daiList,
        });
      });
    });
  }
  return dropdownData;
}
